import React, { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import SellerLanding from "@/pages/SellerLanding";
import SellerSubmit from "@/pages/SellerSubmit";
import SellerDashboard from "@/pages/SellerDashboard";
import BuyerProfile from "@/pages/BuyerProfile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminExport from "@/pages/AdminExport";
import PhotographyBooking from "@/pages/PhotographyBooking";
import { HowItWorks } from "@/pages/StaticPages";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Complaints from "@/pages/Complaints";
import CookieBanner from "@/components/CookieBanner";
import Zoekservice from "@/pages/Zoekservice";
import SpoedZoekservice from "@/pages/SpoedZoekservice";
import Careers from "@/pages/Careers";
import MyWoonVerder from "@/pages/MyWoonVerder";
import AdminCRM from "@/pages/AdminCRM";
import AuthGate from "@/components/AuthGate";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "auto" }); }, [pathname]);
  return null;
}

function AdminOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10">Laden…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/login" replace />;
  return children;
}
function AuthOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10">Laden…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Shell() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/woningen" element={<AuthGate><Properties /></AuthGate>} />
          <Route path="/woning/:id" element={<AuthGate><PropertyDetail /></AuthGate>} />
          <Route path="/woning-verkopen" element={<SellerLanding />} />
          <Route path="/woning-aanmelden" element={<SellerSubmit />} />
          <Route path="/woning-zoeken" element={<BuyerProfile />} />
          <Route path="/fotografie" element={<PhotographyBooking />} />
          <Route path="/hoe-het-werkt" element={<HowItWorks />} />
          <Route path="/over-ons" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/algemene-voorwaarden" element={<Terms />} />
          <Route path="/voorwaarden" element={<Terms />} />
          <Route path="/klachten" element={<Complaints />} />
          <Route path="/zoekservice" element={<Zoekservice />} />
          <Route path="/spoed-zoekservice" element={<SpoedZoekservice />} />
          <Route path="/spoed" element={<SpoedZoekservice />} />
          <Route path="/werk-bij-ons" element={<Careers />} />
          <Route path="/carriere" element={<Careers />} />
          <Route path="/mijn-woon-verder" element={<MyWoonVerder />} />
          <Route path="/admin/crm" element={<AdminOnly><AdminCRM /></AdminOnly>} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verkoper" element={<AuthOnly><SellerDashboard /></AuthOnly>} />
          <Route path="/admin" element={<AdminOnly><AdminDashboard /></AdminOnly>} />
          <Route path="/admin/export" element={<AdminOnly><AdminExport /></AdminOnly>} />
          <Route path="*" element={<div className="max-w-3xl mx-auto py-20 px-4 text-center"><h1 className="font-display text-5xl font-extrabold">404</h1><p className="mt-3 text-slate-600">Deze pagina bestaat niet.</p></div>} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
      <Toaster position="top-right" richColors />
    </>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
